export default __webpack_public_path__ + "static/media/default-light.b83a180a.png";